import script from "./PostLoginModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PostLoginModal.vue?vue&type=script&setup=true&lang=js"

import "./PostLoginModal.vue?vue&type=style&index=0&id=5109fc42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5109fc42"]])

export default __exports__